import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';

import { useStatusItems, useTypeItems } from '../data';
import convertFilter from './convertFilter';
import { actions } from '../redux';
import { itemsOnPage } from './data';

const useModel = () => {
  const dispatch = useDispatch();
  const { coupons, actionProcessing } = useSelector(state => state.sportHistory, shallowEqual);

  const statusItems = useStatusItems();
  const typeItems = useTypeItems();

  const [values, setValues] = useState(() => {
    const date = dayjs().startOf('day');

    return {
      userId: '',
      from: date.toDate(),
      to: date.add(1, 'day').toDate(),
      couponId: '',
      type: typeItems,
      status: statusItems,
      itemsOnPage,
      page: 0,
      username: ''
    }
  });

  const pageCount = Math.ceil(coupons.count / Number(values.itemsOnPage)) ?? 1;

  const activeItemsOnPage = values.itemsOnPage.find(item => item.active);

  const handleSubmit = e => {
    e.preventDefault();

    if (!actionProcessing) {
      dispatch(actions.getSportHistory(convertFilter(values)));
    }
  };

  const syntheticSubmit = () => {
    handleSubmit(new Event('submit'));
  };

  useEffect(() => {
    syntheticSubmit();
  }, [values.page]);

  const handlePageChange = value => {
    setValues(ps => ({
      ...ps,
      page: value,
    }));
  };

  useEffect(() => {
    if ((values.page > pageCount - 1 && pageCount - 1 >= 0) || pageCount === 0) handlePageChange(0);
  }, [values.page, pageCount]);

  const handleItemsOnPageChange = value => {
    setValues(ps => ({
      ...ps,
      itemsOnPage: value,
    }));
  };

  const handleUserIdChange = value => {
    if (/^\d*$/.test(value)) {
      setValues(ps => ({
        ...ps,
        userId: value,
      }));
    }
  };

  const handleFromChange = value => {
    setValues(ps => ({
      ...ps,
      from: value ? dayjs(value).toDate() : new Date(),
    }));
  };

  const handleToChange = value => {
    setValues(ps => ({
      ...ps,
      to: value ? dayjs(value).toDate() : new Date(),
    }));
  };

  const handleCouponIdChange = value => {
    setValues(ps => ({
      ...ps,
      couponId: value,
    }));
  };

  const handleTypeChange = value => {
    setValues(ps => ({
      ...ps,
      type: value,
    }));
  };

  const handleUsernameChange = value => {
    setValues(ps => ({
      ...ps,
      username: value,
    }));
  };

  const handleStatusChange = value => {
    setValues(ps => ({
      ...ps,
      status: value,
    }));
  };

  return {
    input: {
      values,
      handleUserIdChange,
      handleFromChange,
      handleToChange,
      handleCouponIdChange,
      handleTypeChange,
      handleStatusChange,
      handleUsernameChange,
      handlePageChange,
      handleItemsOnPageChange,
      handleSubmit,
    },
    output: {
      actionProcessing,
      coupons,
      activeItemsOnPage,
    },
  };
};

export default useModel;
